<template>
  <AdminLayout v-model:activeTab="view" @toggle="handleToggle">
    <!-- ══════════════════════════════════════════
        INVENTARIO DE ACTIVOS
        key: inventario_activos
    ══════════════════════════════════════════ -->

    <div v-if="view === 'areas_trabajo'"><CrudAreasTrabajo /></div>
    <div v-if="view === 'activos_categorias'"><CrudCategoriasActivo /></div>
    <div v-if="view === 'activos_fijos'"><CrudActivosFijos /></div>
    <!-- ══════════════════════════════════════════
         OPERACIONES / MANTENIMIENTO
         key: operaciones_mantenimiento
    ══════════════════════════════════════════ -->
    <div v-if="view === 'eventos'"><CrudEventos /></div>

    <!-- ══════════════════════════════════════════
         CATÁLOGOS
         key: catalogos_mantenimiento
    ══════════════════════════════════════════ -->
    <div v-if="view === 'moldes'"><CrudMoldes /></div>
    <div v-if="view === 'tipos'"><CrudTiposEvento /></div>

    <!-- ══════════════════════════════════════════
         INVENTARIO
         key: inventario
    ══════════════════════════════════════════ -->
    <div v-if="view === 'consumo_materia_prima'"><ConsumoMateriaPrima /></div>
    <div v-if="view === 'scrap_almacen_laser'"><ScrapAlmacenLaser /></div>
    <div v-if="view === 'vena_scrap'"><VenaScrap /></div>
    <div v-if="view === 'inventario'"><Inventario /></div>
    <div v-if="view === 'cat_productos'"><CrudProductos /></div>
    <div v-if="view === 'cat_maquinas'"><CrudCatMaquinas /></div>
    <div v-if="view === 'operadores'"><CrudOperadores /></div>
    <div v-if="view === 'pigmentos'"><CrudPigmentos /></div>
    <div v-if="view === 'tpus'"><CrudTpus /></div>
    <div v-if="view === 'codigos_defectos'"><CrudCodigosDefectos /></div>

    <!-- ══════════════════════════════════════════
         PEDIDOS
         key: pedidos
    ══════════════════════════════════════════ -->
    <div v-if="view === 'clientes'"><CrudClientes /></div>
    <div v-if="view === 'articulos'"><CrudArticulos /></div>
    <div v-if="view === 'pedidos'"><CrudPedidos /></div>
    <div v-if="view === 'disenos'"><CrudDisenos /></div>

    <!-- ══════════════════════════════════════════
         ALMACÉN
         key: almacen
    ══════════════════════════════════════════ -->
    <div v-if="view === 'pedidos_almacen'"><CrudPedidosSeguimiento /></div>

    <!-- ══════════════════════════════════════════
         INYECCIÓN
         key: inyeccion
    ══════════════════════════════════════════ -->
    <div v-if="view === 'reporte_produccion'"><ReporteProduccionInyeccion /></div>

    <!-- ══════════════════════════════════════════
         PRODUCCIÓN
         key: tablero
    ══════════════════════════════════════════ -->
    <div v-if="view === 'consumo_mp'"><ConsumoMateriaPrimaDashboard /></div>
    <div v-if="view === 'stats_vena_scrap'"><MermasVenaScrapDashboard /></div>
    <div v-if="view === 'scrap_almacen'"><ScrapAlmacenLaserDashboard /></div>

    <!-- ══════════════════════════════════════════
         MANTENIMIENTO INDUSTRIAL
         key: mantenimiento_ops
    ══════════════════════════════════════════ -->
    <div v-if="view === 'maquinas'"><CrudMaquinas /></div>
    <div v-if="view === 'actividades'"><CrudActividades /></div>
    <div v-if="view === 'rutinas'"><CrudRutinas /></div>
    <div v-if="view === 'refacciones'"><CrudRefacciones /></div>
    <div v-if="view === 'calendario'"><CalendarioMtto ref="calendarioRef" /></div>
    <div v-if="view === 'mtto_preventivo'"><EjecucionPreventivo /></div>
    <div v-if="view === 'mtto_correctivo'"><EjecucionCorrectivo /></div>
  </AdminLayout>
</template>

<script setup>
import { ref } from "vue";
import AdminLayout from "@/components/Layout/AdminLayout.vue";
import { useAuthStore } from "@/store/useAuthStore";

// ── Operaciones / Mantenimiento ───────────────────────────────
import CrudEventos from "@/components/Mantenimientos/CrudEventos.vue";

// ── Catálogos ─────────────────────────────────────────────────
import CrudMoldes from "@/components/Mantenimientos/CrudMoldes.vue";
import CrudTiposEvento from "@/components/Mantenimientos/CrudTiposEvento.vue";

// ── Inventario ────────────────────────────────────────────────
import Inventario from "@/components/Inventario/Inventario.vue";
import CrudProductos from "@/components/Inventario/CrudProductos.vue";
import CrudCatMaquinas from "@/components/Inventario/CrudCatMaquinas.vue";
import CrudOperadores from "@/components/Inventario/CrudOperadores.vue";
import CrudPigmentos from "@/components/Inventario/CrudPigmentos.vue";
import CrudTpus from "@/components/Inventario/CrudTpus.vue";
import CrudCodigosDefectos from "@/components/Inventario/CrudCodigosDefectos.vue";
import ConsumoMateriaPrima from "@/components/Inventario/Formularios/MateriaPrima/ConsumoMateriaPrima.vue";
import ScrapAlmacenLaser from "@/components/Inventario/Formularios/ScrapAlmacenLaser/ScrapAlmacenLaser.vue";
import VenaScrap from "@/components/Inventario/Formularios/VenaScrap/VenaScrap.vue";

// ── Pedidos ───────────────────────────────────────────────────
import CrudClientes from "@/components/TableroProduccion/CrudClientes.vue";
import CrudArticulos from "@/components/TableroProduccion/CrudArticulos.vue";
import CrudPedidos from "@/components/TableroProduccion/Pedidos/CrudPedidos.vue";
import CrudDisenos from "@/components/TableroProduccion/Disenos/CrudDisenos.vue";

// ── Almacén ───────────────────────────────────────────────────
import CrudPedidosSeguimiento from "@/components/TableroProduccion/SeguimientoPedidos/CrudPedidosSeguimiento.vue";

// ── Inyección ─────────────────────────────────────────────────
import ReporteProduccionInyeccion from "@/components/Inyeccion/ReporteProduccion.vue";

// ── Mantenimiento industrial ──────────────────────────────────
import CrudMaquinas from "@/components/Maquinas/CrudMaquinas.vue";
import CrudActividades from "@/components/Maquinas/CrudActividades.vue";
import CrudRefacciones from "@/components/Maquinas/CrudRefacciones.vue";
import CrudRutinas from "@/components/Maquinas/CrudRutinas.vue";
import CalendarioMtto from "@/components/Maquinas/Calendario/CalendarioMtto.vue";
import EjecucionPreventivo from "@/components/Maquinas/EjecucionPreventivo.vue";
import EjecucionCorrectivo from "@/components/Maquinas/EjecucionCorrectivo.vue";

// ── Inventario de activos ──────────────────────────────────
import CrudCategoriasActivo from "@/components/InventarioActivos/CrudCategoriasActivo.vue";
import CrudActivosFijos from "@/components/InventarioActivos/CrudActivosFijos.vue";
import CrudAreasTrabajo from "@/components/InventarioActivos/CrudAreasTrabajo.vue";

// ── Reportes / Estadísticas ─────────────────────────────────────
import ConsumoMateriaPrimaDashboard from "../Inventario/Reportes/ConsumoMateriaPrima/ConsumoMateriaPrimaDashboard.vue";
import MermasVenaScrapDashboard from "../Inventario/Reportes/MermasVenaScrap/MermasVenaScrapDashboard.vue";
import ScrapAlmacenLaserDashboard from "../Inventario/Reportes/ScrapAlmacenLaser/ScrapAlmacenLaserDashboard.vue";

// ─────────────────────────────────────────────────────────────
const authStore = useAuthStore();

// ── Tab inicial por rol ─────────────────────────────────────
// business_owner y superadmin entran directo a Estadísticas;
// el resto conserva "eventos" (Mantenimientos) como antes.
const ROLE_DEFAULT_TAB = {
  superadmin: "consumo_mp",
  business_owner: "consumo_mp",
};

const view = ref(ROLE_DEFAULT_TAB[authStore.role] ?? "eventos");
const calendarioRef = ref(null);

function handleToggle() {
  // Notificar al calendario para que redibuje FullCalendar si está activo
  if (view.value === "calendario") {
    calendarioRef.value?.onSidebarToggle?.();
  }
}
</script>

<style scoped>
.divisan-card {
  background-color: var(--d-cream);
  border-radius: 12px;
  border-left: 5px solid var(--d-green);
}
.text-cafe {
  color: var(--d-brown);
}
.text-muted-divisan {
  color: var(--d-text-muted);
  font-weight: 600;
}
</style>
